export const popupModalJsFiles = {
  unbundled: {
    dev: [
      "public/js/underscore-1_6_0.js",
      "public/js/backbone-1_1_2.js",
      "public/js/mustache.js",
      "public/js/jquery.timeago.js",
      "public/js/jquery.timeago.i18n.js",
      "public/js/jquery.timeago.ext.js",
      "public/js/jquery.cookie.js",
      "public/js/libs/jquery.tooltipster.min.js",
      "public/js/build/popupModalBundle.js",
      "public/js/modules/jquery.truncate.js",
      "public/js/modules/global.js",
      "public/js/modules/compatible-post-message.js",
      "public/js/modules/hypeHelper.js",
      "public/js/modules/yt.js",
      "public/js/modules/hypeHelper.isEmbed.js",
      "public/js/build/hypeHelper.generateEmbedBundle.js",
      "public/js/modules/hype.js",
      "public/js/modules/baseView.js",
      "public/js/modules/personalized-theme-stylesheet.js",
      "public/js/modules/share-tooltip.js",
      "public/js/flickity-2_0_4.min.js"
    ]
  },
  bundled: {
    dev: ["public/js/build/dev/popup-modal.js"],
    prod: ["public/js/build/prod/popup-modal.min.js"]
  }
};
